/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastname_Label1Inputs */

const en_lastname_label1 = /** @type {(inputs: Lastname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

const de_lastname_label1 = /** @type {(inputs: Lastname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Lastname_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const lastname_label1 = /** @type {((inputs?: Lastname_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastname_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lastname_label1(inputs)
	return en_lastname_label1(inputs)
});
export { lastname_label1 as "lastName_label" }